import { QRCodeSVG } from "qrcode.react";
import { QrCode, CheckCircle, Printer, ShoppingCart } from "lucide-react";

const QRCodeSection = ({
  generateQRCode,
  copyToClipboard,
  showCopySuccess,
}) => (
  <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500">
    <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-orange-50 to-red-50">
        <h3 className="text-lg font-bold text-gray-900 flex items-center">
          <QrCode className="w-5 h-5 mr-2 text-orange-600" />
          QR Code for Customer Menu
        </h3>
      </div>
      <div className="p-6 text-center">
        <div className="inline-block p-8 bg-white rounded-2xl shadow-lg border-2 border-gray-200 mb-6">
          <QRCodeSVG
            value={generateQRCode()}
            size={200}
            level="H"
            includeMargin={true}
            className="mx-auto"
          />
        </div>
        <div className="space-y-4">
          <p className="text-gray-600 max-w-md mx-auto">
            Customers can scan this QR code to access your menu and place orders
            directly from their phones.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
            <button
              onClick={copyToClipboard}
              className="px-6 py-3 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg font-medium hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center"
            >
              {showCopySuccess ? (
                <>
                  <CheckCircle className="w-5 h-5 mr-2" />
                  Copied!
                </>
              ) : (
                <>
                  <QrCode className="w-5 h-5 mr-2" />
                  Copy Link
                </>
              )}
            </button>
            <a
              href={generateQRCode()}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-gradient-to-r from-gray-500 to-slate-600 text-white rounded-lg font-medium hover:shadow-lg transform hover:scale-105 transition-all duration-200"
            >
              Open Menu
            </a>
          </div>
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mt-6">
            <p className="text-sm text-blue-800 font-medium">
              Menu URL: {generateQRCode()}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
      <h4 className="text-lg font-bold text-gray-900 mb-4">
        How to Use QR Codes
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          {
            step: "1",
            title: "Print QR Code",
            description: "Download or print the QR code and place it on tables",
            icon: Printer,
          },
          {
            step: "2",
            title: "Customer Scans",
            description: "Customers use their phone camera to scan the code",
            icon: QrCode,
          },
          {
            step: "3",
            title: "Order & Pay",
            description: "They view menu, place orders, and can pay online",
            icon: ShoppingCart,
          },
        ].map((item, index) => (
          <div
            key={item.step}
            className="text-center p-4 animate-in slide-in-from-bottom-4 fill-mode-both"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <item.icon className="w-8 h-8 text-white" />
            </div>
            <h5 className="font-bold text-gray-900 mb-2">{item.title}</h5>
            <p className="text-sm text-gray-600">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default QRCodeSection;
